import React from 'react'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'

export const LINK_ROUTE_DIALOG = 'LINK_ROUTE_DIALOG'

export class LinkRouteDialog extends React.PureComponent {
  onSave = (e) => {
    const { onSave } = this.props
    const routeId = this._routeId.value
    onSave(routeId)
  }

  render () {
    const { route, routes, onRequestClose } = this.props
    const routeId = route ? route.id : ''

    return (
      <ModalOverlay
        title='Link Route'
        maxWidth={'380px'}
        onRequestClose={onRequestClose}>
        <div>
          Choose a route:
          <form>
            <select defaultValue={routeId} ref={r => { this._routeId = r }}>
              {routes.map((r, idx) => <option key={idx} value={r.id}>{r.name}</option>)}
            </select>
          </form>
          <CTA onClick={this.onSave}>Save</CTA>
          <CTA link onClick={onRequestClose}>Cancel</CTA>
        </div>
      </ModalOverlay>
    )
  }
}
